<div>
    <div class="main-content">
        <header class="top-header">
            <h3>Bridge Details</h3>
        </header>

        <form class="form" [formGroup]="updateBridgeForm" (ngSubmit)="onSubmit()" *ngIf="updateBridgeForm">
            <div class="form-row">
                <div class="form-group">
                    <label>Bridge Name <small>*</small></label>
                    <input type="text" placeholder="Bridge Name" formControlName="bridgeName"/>
                    <div class="error"
                         *ngIf="updateBridgeForm.get('bridgeName')?.invalid && updateBridgeForm.get('bridgeName')?.touched">
                        <small *ngIf="updateBridgeForm.get('bridgeName')?.errors?.['required']">Bridge Name is
                            required.</small>
                    </div>
                </div>
                <div class="form-group">
                    <label>Bridge ESN <small>*</small></label>
                    <input type="text" placeholder="Bridge ESN" formControlName="bridgeEsn"
                           (input)="onEsnInput($event)"/>
                    <div class="error"
                         *ngIf="updateBridgeForm.get('bridgeEsn')?.invalid && updateBridgeForm.get('bridgeEsn')?.touched">
                        <small *ngIf="updateBridgeForm.get('bridgeEsn')?.errors?.['required']">Bridge ESN is
                            required.</small>
                    </div>
                </div>
                <div class="form-group">
                    <label>Serial Number <small>*</small></label>
                    <input type="text" placeholder="Serial Number" formControlName="serialNumber"
                           (input)="onSerialNumberInput($event)"/>
                    <div class="error"
                         *ngIf="updateBridgeForm.get('serialNumber')?.invalid && updateBridgeForm.get('serialNumber')?.touched">
                        <small *ngIf="updateBridgeForm.get('serialNumber')?.errors?.['required']">Serial Number is
                            required.</small>
                    </div>
                </div>
            </div>

            <div class="form-row">
                <div class="form-group">
                    <label>Bridge Type <small>*</small></label>
                    <select formControlName="bridgeType" id="bridgeType">
                        <option *ngFor="let option of bridgeTypes" [value]="option.value">{{ option.label }}</option>
                    </select>
                    <div class="error"
                         *ngIf="updateBridgeForm.get('bridgeType')?.invalid && updateBridgeForm.get('bridgeType')?.touched">
                        <small *ngIf="updateBridgeForm.get('bridgeType')?.errors?.['required']">Bridge Type is
                            required.</small>
                    </div>
                </div>
                <div class="form-group">
                    <label>Bridge UUID</label>
                    <div class="uuid-row">
                        <input type="text" formControlName="bridgeId" readonly/>
                        <app-copy-button
                                [value]="updateBridgeForm.get('bridgeId')?.value"
                                copyTitle="Copy Bridge UUID">
                        </app-copy-button>
                    </div>
                    <small class="helper-text">Bridge UUID cannot be changed.</small>
                </div>
            </div>

            <div class="form-row">
                <div class="form-group">
                    <label>Organization Name <small>*</small></label>
                    <input formControlName="organization" readonly/>
                    <small class="helper-text">Organization cannot be changed after bridge creation.</small>
                </div>
            </div>

            <div class="button-row">
                <button class="btn-save" type="submit">
                    <fa-icon [icon]="['fas', 'square-plus']" style="padding-right: 3px;"></fa-icon>
                    Update
                </button>
                <button class="btn-cancel" type="button" (click)="onCancel()">
                    <fa-icon [icon]="['fas', 'square-xmark']" style="padding-right: 3px;"></fa-icon>
                    Cancel
                </button>
            </div>
        </form>

        <section class="credentials-section" *ngIf="updateBridgeForm">
            <div class="credentials-header">
                <h4>Credentials</h4>
                <button class="btn-save" type="button" (click)="createCredential()">
                    <fa-icon [icon]="['fas', 'square-plus']" style="padding-right: 3px;"></fa-icon>
                    Create Credential
                </button>
            </div>

            <div class="responsive-table-wrapper">
                <table>
                    <thead>
                    <tr>
                        <th>Credential</th>
                        <th>Status</th>
                        <th>Last Used</th>
                        <th>Created At</th>
                        <th>Actions</th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr *ngFor="let credential of credentials">
                        <td><span class="credential-badge">{{ credential.masked_key }}</span></td>
                        <td>
                            <span class="status-pill" [class.active]="credential.is_active"
                                  [class.inactive]="!credential.is_active">
                                {{ credential.is_active ? 'Active' : 'Revoked' }}
                            </span>
                        </td>
                        <td>{{ formatRelativeTime(credential.last_used_at) }}</td>
                        <td>{{ credential.created_at | date:'dd MMM yyyy' }}</td>
                        <td>
                            <button
                                    *ngIf="credential.is_active"
                                    class="btn-cancel revoke-button"
                                    type="button"
                                    (click)="revokeCredential(credential)"
                                    [disabled]="credential._revoking">
                                Revoke
                            </button>
                        </td>
                    </tr>
                    <tr *ngIf="credentials.length === 0">
                        <td colspan="5">No credentials found.</td>
                    </tr>
                    </tbody>
                </table>
            </div>
        </section>
    </div>
</div>

<div *ngIf="showSuccessModal" class="confirmation-modal">
    <div class="modal-content success-modal-content">
        <header class="top-header modal-header">
            <h3>Credential Created</h3>
            <p>Save this key securely. It will not be fully shown again.</p>
        </header>

        <div class="generated-key-box">{{ generatedRawKey }}</div>

        <div class="button-row">
            <app-copy-button [value]="generatedRawKey" copyTitle="Copy API key"></app-copy-button>
            <button class="btn-cancel" type="button" (click)="closeSuccessModal()">
                <fa-icon [icon]="['fas', 'square-xmark']" style="padding-right: 3px;"></fa-icon>
                Close
            </button>
        </div>
    </div>
</div>
